import { PdfViewer } from "../../../../../../components/PdfViewer/PdfViewer";
import { RichTextViewerWithFetch } from "../../../../../../components/RichTextViewerWithFetch/RichTextViewerWithFetch";
import { useStoreActions } from "../../../../../../contexts";
import { useLegalTerms } from "../../../../../../hooks/reactQuery/queries/useLegalTerms";
import { jsx as _jsx } from "react/jsx-runtime";
export function TermsOfServiceContent(_ref) {
  let {
    relationship,
    termsOfService
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    legalTerms
  } = useLegalTerms();
  const {
    type
  } = termsOfService;
  if (type === 'pdf') {
    return /*#__PURE__*/_jsx(PdfViewer, {
      hideSinglePageLoader: true,
      getFileUrl: async () => await api.business.getLegalTermsDownloadURL(termsOfService.pdf.pdfName, relationship.vendor.id),
      pdfUniqueName: termsOfService.pdf.pdfName
    });
  }
  const textId = type === 'richText' ? termsOfService.richText.textId : termsOfService.quill.textId;
  return /*#__PURE__*/_jsx(RichTextViewerWithFetch, {
    queryKey: textId !== null && textId !== void 0 ? textId : undefined,
    fetchText: async () => {
      var _legalTerms$find$rich, _legalTerms$find;
      if (textId) {
        const {
          value
        } = await api.texts.getLegalTermsRichTextContent(relationship.id, textId);
        return value;
      }
      return (_legalTerms$find$rich = (_legalTerms$find = legalTerms.find(lt => lt.id === termsOfService.legalTermsId)) === null || _legalTerms$find === void 0 ? void 0 : _legalTerms$find.richTextContent) !== null && _legalTerms$find$rich !== void 0 ? _legalTerms$find$rich : [];
    }
  });
}